import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import RoleChecker from '@components/RoleChecker';
import { RolesTypes } from '@utils/rolesConstants';
import { Button, Tooltip, Modal } from 'antd';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const { confirm } = Modal;

interface IAdminActionsProps {
  entityToExclude: string;
  ruleToNotExclude?: boolean;
  onEdit?: () => void;
  onDelete: () => void;
  alertDelete: string;
  extraActions?: ReactNode;
  isButtonLink?: boolean;
  isEditDisabled?: boolean;
  isDeleteDisabled?: boolean;
  needPermission?: boolean;
  hasEditPermission?: RolesTypes;
  hasDeletePermission?: RolesTypes;
}

const AdminActions: React.FC<IAdminActionsProps> = ({
  entityToExclude,
  ruleToNotExclude,
  onEdit,
  onDelete,
  alertDelete,
  extraActions,
  isButtonLink,
  isEditDisabled,
  isDeleteDisabled,
  needPermission,
  hasEditPermission,
  hasDeletePermission,
}) => {
  const { t } = useTranslation('admin-actions');

  const showDelConfirm = () => {
    confirm({
      title: <h3>{t('deleteModal.title', { entityToExclude })}</h3>,
      icon: (
        <ExclamationCircleOutlined
          style={{
            color: 'var(--primary-color)',
          }}
        />
      ),
      content: alertDelete,
      okText: t('buttons.deleteYes'),
      cancelText: t('buttons.deleteNo'),
      okButtonProps: { type: 'primary' },
      afterClose: () => document.body.style.removeProperty('overflow'),
      onOk: onDelete,
    });
  };

  return (
    <div>
      {extraActions}
      {onEdit &&
        (needPermission ? (
          <RoleChecker role={hasEditPermission}>
            <Tooltip title={t('buttons.editButton')}>
              <Button
                type={isButtonLink ? 'link' : 'default'}
                style={{
                  padding: isButtonLink ? 'inherit' : '0 8px',
                  margin: '0 8px',
                  marginRight: !ruleToNotExclude ? 8 : 0,
                }}
                className="button-edit"
                onClick={onEdit}
                disabled={isEditDisabled}
              >
                <EditOutlined />
              </Button>
            </Tooltip>
          </RoleChecker>
        ) : (
          <Tooltip title={t('buttons.editButton')}>
            <Button
              type={isButtonLink ? 'link' : 'default'}
              style={{
                padding: isButtonLink ? 'inherit' : '0 8px',
                margin: '0 8px',
                marginRight: !ruleToNotExclude ? 8 : 0,
              }}
              className="button-edit"
              onClick={onEdit}
              disabled={isEditDisabled}
            >
              <EditOutlined />
            </Button>
          </Tooltip>
        ))}

      {!ruleToNotExclude &&
        (needPermission ? (
          <RoleChecker role={hasDeletePermission}>
            <Tooltip title={t('buttons.deleteButton')}>
              <Button
                type={isButtonLink ? 'link' : 'default'}
                style={{
                  padding: isButtonLink ? 'inherit' : '0 8px',
                }}
                danger
                disabled={isDeleteDisabled}
                onClick={(e: React.MouseEvent) => {
                  e.stopPropagation();
                  showDelConfirm();
                }}
              >
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </RoleChecker>
        ) : (
          <Tooltip title={t('buttons.deleteButton')}>
            <Button
              type={isButtonLink ? 'link' : 'default'}
              style={{
                padding: isButtonLink ? 'inherit' : '0 8px',
              }}
              danger
              disabled={isDeleteDisabled}
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                showDelConfirm();
              }}
            >
              <DeleteOutlined />
            </Button>
          </Tooltip>
        ))}
    </div>
  );
};

export default AdminActions;
